import React, { useState } from 'react';
import MonacoEditor from '@monaco-editor/react';
import "../../styles/swe.css"
import { serverURL } from '../../config/urls';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../../config/firebase-logging';

function CodeSnippet(props) {
  const options = {scrollbar: {alwaysConsumeMouseWheel: false,},scrollBeyondLastLine: false,minimap: {enabled: false,}}

  const [showOutput, setShowOutput] = useState(false);
  const [output, setOutput] = useState("")
  const [code, setCode] = useState(props.code)

  function handleEditorChange(newValue, event) {
    setCode(newValue)
  }

  async function runCode() {
    if (process.env.REACT_APP_ENVIRONMENT === "production") {
      logEvent(analytics, 'career_interaction')
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code }),
    };
    const response = await fetch(serverURL + "/run_code", requestOptions);
    const result = await response.json();
    setOutput(result.output);
    setShowOutput(true);
  }

  return (
    <div className='row' style={{alignItems: 'flex-start'}}>
      <div style={{ width: showOutput ? "50%" : "100%" }}>
        <div className='editor-padding'></div>
        <MonacoEditor theme='vs-dark' language='python' height={props.height} value={code} onChange={handleEditorChange} options={options} />
        <button className='primary-btn' style={{marginTop: "5px"}} onClick={runCode}>Run Code</button>
      </div>
      {showOutput && <pre className="output" style={{height: props.height}}>{output}</pre>}
    </div>
  )

}

export default CodeSnippet;